import { InspectionViewModel } from '../data/viewmodels.types';

/**
 * Free-text match for the front-page inspection search. The term is TRIMMED:
 * mobile keyboards and copy-paste routinely add stray leading/trailing spaces,
 * and " QA" would otherwise miss every "QA ..." match while a spaces-only query
 * would filter everything to nothing. An empty (or whitespace-only) term
 * matches everything.
 *
 * Yard inspections carry their context on the mine location, not an asset - both
 * are searched (the old history screen searched assets only and missed them).
 */
export function inspectionMatchesSearch(
  model: InspectionViewModel,
  rawTerm: string,
): boolean {
  const term = rawTerm.trim().toLowerCase();
  if (!term) return true;
  return Boolean(
    model.asset?.name?.toLowerCase().includes(term) ||
    model.asset?.model?.name?.toLowerCase().includes(term) ||
    model.asset?.model?.assetType?.toLowerCase().includes(term) ||
    model.asset?.customerName?.toLowerCase().includes(term) ||
    model.asset?.siteName?.toLowerCase().includes(term) ||
    model.mineLocation?.mineLocation?.name?.toLowerCase().includes(term) ||
    model.mineLocation?.customerName?.toLowerCase().includes(term) ||
    model.mineLocation?.siteName?.toLowerCase().includes(term) ||
    model.inspection.inspectorName?.toLowerCase().includes(term) ||
    model.inspection.inspectionCategoryTypes?.some((c) =>
      c.category.toLowerCase().includes(term),
    ),
  );
}
